var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showError)?_c(_vm.component,{tag:"component"}):_vm._e(),(_vm.showError)?_c('ErrorCarregar',{attrs:{"titulo":_vm.errorTitle,"texto":_vm.errorMessage,"show":_vm.showError,"imagem-url":_vm.svgNome}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }